export default __webpack_public_path__ + "static/media/slide1.27a96ef1.jpg";